/**
 * Below are the data tags attributes to be used on various buttons, inputs and other
 * elements for SEO purposes. These attribute values are provided by Dejan and his team.
 *
 * `CTA` refers to a call-to-action button. The button should have two tags:
 * `data-ctaclick={CTA}` and `data-ctatext={TEXT}`. `TEXT` refers to the text label for
 * the button.
 * For example:
 * <button data-ctaclick="add_business" data-ctatext="Add a Business">Add a Business</button>
 *
 * `INPUT` refers to a form input field. The value is for the `data-ctaclick` attribute. It does
 * not have a `data-ctatext` attribute.
 *
 * `SUBMIT` refers to the submit button. The button should have two tags:
 * `data-ctaclick={CTA}` and `data-ctatext={TEXT}`. `TEXT` refers to the text label for
 * the button.
 * For example:
 * <button type="submit" data-ctaclick="form_submit" data-ctatext="Submit Quote">
 *  Submit Quote
 * </button>
 *
 * **NOTE**: `PROFILE.CTA.PHONE` elements should also have a `data-mode` attribute added, which
 * refers to the contact method type.
 * Accepted values are: 'Work' <TO BE CONFIRMED>
 *
 */

const ADD_BUSINESS_FORM = {
  CTA: 'add_business',
};
const GTM_DATA_LAYER_NAME = 'PageDataLayer';

const ENQUIRY_FORM = {
  CTA: 'Enquiry',
  INPUT: {
    NAME: 'enquiry_engaged_name',
    EMAIL: 'enquiry_engaged_email',
    PHONE: 'enquiry_engaged_contact',
  },
};

const PROFILE = {
  CTA: {
    PHONE: 'Phone Call',
    EMAIL: ENQUIRY_FORM.CTA,
    WEBSITE: 'Website',
    BOOKING: 'Booking',
  },
};

const REVIEW_FORM = {
  CTA: 'Write Review',
  INPUT: {
    NAME: 'review_engaged_username',
    EMAIL: 'review_engaged_user_email',
    PROFILE: 'review_engaged_businessname',
    LOCATION: 'review_engaged_location',
  },
  SUBMIT: 'form_submit',
};

const QUOTE_FORM = {
  CTA: 'Quote',
  INPUT: {
    NAME: 'quote_engaged_username',
    EMAIL: 'quote_engaged_email',
    SUBURB: 'quote_engaged_suburb',
    PHONE: 'quote_engaged_phonenumber',
  },
  SUBMIT: 'form_submit',
};

export {
  ADD_BUSINESS_FORM,
  ENQUIRY_FORM,
  PROFILE,
  REVIEW_FORM,
  QUOTE_FORM,
  GTM_DATA_LAYER_NAME,
};
